import React from "react";
import { Card } from "./styles";

import ReportsChoView from "../../views/ReportsCho/index.jsx";

export default function HomeCho() {
  return (
    <div>
      <Card>
        <ReportsChoView />
      </Card>
    </div>
  );
}
